"use strict";

exports.__esModule = true;
exports.COLORS = {
  primary: "#efefef"
};
exports.SIZES = {
  normal: 12,
  xxl: 40
};